import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";
@Component({
  selector: 'app-bar-chart-never-logged-sex',
  templateUrl: './bar-chart-never-logged-sex.component.html',
  styleUrls: ['./bar-chart-never-logged-sex.component.css']
})
export class BarChartNeverLoggedSexComponent implements OnInit {

        // per inizializzazione
        getAuthState: Observable<any>;
        getDoctorState: Observable<any>;
        isAuthenticated: boolean;
        user = null;
        errorMessage = null;
        subscription1: Subscription;
        subscription2: Subscription;
        subscription3: Subscription;
        subscription4: Subscription;
        subscription5: Subscription;
        title = "Sesso";
        destination = 'never-logged';
        // elementi che servono per il bar-chart
        canvas: any;
        ctx: any;
        myChartNeverLoggedPatients: Chart;
  
        // ******************************************************************************************************************
        // seguenti righe: inizializzazione dei pazienti 
        // ******************************************************************************************************************
        neverLoggedGlobalUomo = 0;
        neverLoggedGlobalDonna = 0;
        neverLoggedGlobalAltroSesso = 0;

  
        loggedGlobalUomo = 0;
        loggedGlobalDonna = 0;
        loggedGlobalAltroSesso = 0;

  
  
        UomoGlobalPatients = 0;
        DonnaGlobalPatients = 0;
        AltroSessoGlobalPatients = 0;

 
  
        neverLoggedGlobalPatientsArray = [];
        loggedGlobalPatientsArray = [];
        neverLoggedPatientsGlobal = [];
        // ******************************************************************************************************************
        // bar chart dei pazienti 
        // ******************************************************************************************************************
        public barChartLabelsGlobalNeverLogged = ['UOMO', 'DONNA','NON SPECIFICATO'];
        public barChartTypeGlobalNeverLogged = 'horizontalBar';
        public barChartLegendGlobalNeverLogged = true;
        public barChartDataGlobalNeverLogged = [
          {
            data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal', 'teal','teal'],
            hoverBackgroundColor: ['#066', '#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
          },
          {
            data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered', 'orangered','orangered'],
            hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
          }];
        
  
  
        // constructor
        constructor(private store: Store<AppState>,
                    private doctorService: DoctorService,
                    private snackBar: MatSnackBar) {
          this.getAuthState = this.store.select(selectAuthState);
          this.getDoctorState = this.store.select(selectDoctorState);
        }
        // ******************************************************************************************************************
        // metodo all'inizio
        ngOnInit(): void {
          this.subscription4 = this.getAuthState.subscribe((state) => {
            this.isAuthenticated = state.isAuthenticated;
            this.user = JSON.parse(localStorage.getItem('user'));
            this.errorMessage = state.errorMessage;
            this.retrieveGlobalNeverLoggedUomo();
          });
        }
        ngOnDestroy(): void {
          this.subscription1.unsubscribe();
          this.subscription2.unsubscribe();
          this.subscription3.unsubscribe();
          this.subscription4.unsubscribe();
          this.subscription5.unsubscribe();

        }
        // ******************************************************************************************************************
        // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
        // e in standard e poi tutti
        // i pazienti in ogni categoria per poter calcolare gli attivi
        // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart

        retrieveGlobalNeverLoggedUomo() {
          this.subscription1 = this.doctorService.getNeverLoggedUomoNumber().subscribe(npatients => {
            this.neverLoggedGlobalUomo = parseInt(npatients.toString());
            this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalUomo); // riempio il vettore del bar chart con standard
            this.retrieveGlobalNeverLoggedDonna();

          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
        retrieveGlobalNeverLoggedDonna() {
          this.subscription2 = this.doctorService.getNeverLoggedDonnaNumber().subscribe(npatients => {
            this.neverLoggedGlobalDonna = parseInt(npatients.toString());
            this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalDonna); // riempio vettore del bar-chart con telemedicina
            this.retrieveGlobalNeverLoggedAltroSesso();

          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }

        retrieveGlobalNeverLoggedAltroSesso() {
          this.subscription5 = this.doctorService.getNeverLoggedNoSexNumber().subscribe(npatients => {
            this.neverLoggedGlobalAltroSesso = parseInt(npatients.toString());
            this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalAltroSesso); // riempio vettore del bar-chart con telemedicina
            this.retrieveGlobalUomoDonnaAltro();

          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
      
        retrieveGlobalUomoDonnaAltro() {
          this.subscription3 = this.doctorService.getGlobalUOMODOONNAALTRONumber().subscribe(num => {
            this.UomoGlobalPatients = num[0];
            this.DonnaGlobalPatients = num[1];
            this.AltroSessoGlobalPatients = num[2];
            this.loggedGlobalUomo = this.UomoGlobalPatients - this.neverLoggedGlobalUomo;
            this.loggedGlobalPatientsArray.push(this.loggedGlobalUomo); // riempio il vettore del bar chart con standard           
            this.loggedGlobalDonna = this.DonnaGlobalPatients - this.neverLoggedGlobalDonna;
            this.loggedGlobalPatientsArray.push(this.loggedGlobalDonna); // riempio il vettore del bar chart con telemedicina
            this.loggedGlobalAltroSesso = this.AltroSessoGlobalPatients - this.neverLoggedGlobalAltroSesso;
            this.loggedGlobalPatientsArray.push(this.loggedGlobalAltroSesso); // riempio il vettore del bar chart con standard           
            this.canvasSetting();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
       
        canvasSetting() {
            this.canvas = document.getElementById('myChartNeverLoggedSex') as HTMLCanvasElement;
            this.ctx = this.canvas.getContext('2d');
            this.myChartNeverLoggedPatients = new Chart(this.ctx, {
              type: this.barChartTypeGlobalNeverLogged,
              data: {
                labels: this.barChartLabelsGlobalNeverLogged,
                datasets: this.barChartDataGlobalNeverLogged,
              },
              options: {
                maintainAspectRatio: true,
                responsive: true,
  
                scales: {
                  xAxes: [{
                    display: true,
                    stacked: false,
                    ticks: {
                      fontSize: 12,
                      fontStyle: 'bold',
                      fontFamily: 'Helvetica',
                      fontColor: '#006192'
                    }
                  }],
                  yAxes: [{
                    display: true,
                    stacked: false,
                    ticks: {
                      fontSize: 12,
                      fontStyle: 'bold',
                      fontFamily: 'Helvetica',
                      fontColor: '#006192'
                    }
                  }],
                },
                legend: {
                 
                  display: true,
                  position: 'top',
                  labels: {
                    usePointStyle: true,
                    fontColor: '#006192',
                    fontSize: 18,
                    fontFamily: 'Helvetica',
                  }
                },
                tooltips: {
                  // content: '{pathology}: {number}',
                  backgroundColor: '#1c1c1c',
                  bodyFontSize: 18,
                  titleFontSize: 18,
                  cornerRadius: 5,
                  caretPadding: 10
                },
                title: {
                  display: true,
                  text: "N° di utenti che hanno/non hanno effettuato l'accesso",
                  fontColor: '#006192',
                  fontSize: 20,
                  fontFamily: 'Helvetica',
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                }
              }
            });
            } // dopo aver ottenuto tutti i dati creo il bar chart
        
      }
      